<script>
  import TableFilterText from './TableFilterText'
  import TableFilterBool from './TableFilterBool'
  import TableFilterInt from './TableFilterInt'
  import TableFilterDate from './TableFilterDate'
  import TableFilterValue from './TableFilterValue'

  import {
    QBtn,
    QPopover,
    QInput,
    QDatetimePicker,
    QCheckbox,
    QSearch,
    QIcon,
    date
  } from 'quasar'

  export default {
    name: 'TableFilter',
    components: {
      QBtn,
      QPopover,
      QInput,
      QDatetimePicker,
      QCheckbox,
      QSearch,
      QIcon
    },
    props: ['filters', 'columns'],
    methods: {
      getComponent (type) {
        switch (type) {
          case 'text':
            return TableFilterText;
          case 'bool':
            return TableFilterBool;
          case 'int':
            return TableFilterInt;
          case 'date':
            return TableFilterDate;
          case 'value':
            return TableFilterValue;
        }
      }
    },
    computed: {
      columnsWithFilter () {
        return this.columns.filter(column => column.hasOwnProperty('filter'));
      },
    },
    render (createElement) {
      return createElement('div',
        {
          staticClass: 'row'
        },
        [
          this.columnsWithFilter.map(col => {
            let self = this;
            return createElement(this.getComponent(col.type), {
              props: {
                column: col,
                columns: self.columns
              },
              on: {
                input (query) {
                  self.$emit('input', query);
                }
              }
            })
          })
        ]
      )
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TableFilter/TableFilter.vue